import { GlobalContext } from "components/GlobalContext";
import { useContext, useRef } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

const ToolsLookup = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;

    return (
        <>
            <Row>
                {/*
                    globalContext.roles.some(r => r === "Web.Toolsdd") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Tools/FilterProgrammer" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        Filter Programmer
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Program & Inspect Crew Protect filters
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
    */}
                {
                    globalContext.roles.some(r => r === "Web.Tools") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Tools/EquipmentMassAdd" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        Mass Add Equipment
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Add many equipment or AirCards with preset properties.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                }

                {
                    globalContext.roles.some(r => r === "Web.Tools") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Tools/EquipmentUpdate" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        Equipment Updates
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Process equipment lifecycle changes.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                }

                {
                    globalContext.roles.some(r => r === "Web.Tools") && globalContext.roles.some(r => r === "Web.Opportunities") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Tools/QuickQuote" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        Create a Quick Quote
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Create a quick quote for a customer.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                }

                {
                    globalContext.roles.some(r => r === "Web.QRCodeGenerator") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Tools/QRCodeGenerator" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        QR Code Generator
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Generate QRCodes based on provided urls.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                }
            </Row>
        </>
    );
}

export default ToolsLookup;
